import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    FunctionField,
    DeleteButton,
} from 'react-admin';

import {
    Typography,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@material-ui/core';

// ---------------------------------------------------------------------------
// Row expansion — linked employments
// ---------------------------------------------------------------------------

const LinkedEmploymentsPanel = ({ record }) => {
    const employments = record?.linked_employments ?? [];

    if (!employments.length) {
        return (
            <Box p={2}>
                <Typography variant="body2" color="textSecondary">
                    No employments currently using this job title.
                </Typography>
            </Box>
        );
    }

    return (
        <Box p={2}>
            <Typography variant="subtitle2" gutterBottom>
                Employments using "{record.title}"
            </Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>Surname</TableCell>
                        <TableCell>Job Title (on employment)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {employments.map(e => (
                        <TableRow key={e.id}>
                            <TableCell>{e.first_name}</TableCell>
                            <TableCell>{e.surname}</TableCell>
                            <TableCell>{e.job_title}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
};

// ---------------------------------------------------------------------------
// List
// ---------------------------------------------------------------------------

export const ProductionJobTitleList = props => (
    <List
        {...props}
        sort={{ field: 'title', order: 'ASC' }}
        bulkActionButtons={false}
        title="Job Title Overrides"
        empty={
            <Box p={3}>
                <Typography variant="body1" color="textSecondary">
                    No job title overrides for this production yet. These are added automatically
                    when a production admin confirms a job title that isn't on the HMRC approved list.
                </Typography>
            </Box>
        }
    >
        <Datagrid expand={<LinkedEmploymentsPanel />}>
            <TextField source="title" label="Job Title" />
            <FunctionField
                label="Added By"
                render={record => record.added_by
                    ? `${record.added_by.first_name} ${record.added_by.last_name}`
                    : '—'
                }
            />
            <DateField source="created_at" label="Added" />
            <DeleteButton undoable={false} />
        </Datagrid>
    </List>
);
